<template>
  <nav id="sidebar" class="sidebar js-sidebar">
    <div class="sidebar-content js-simplebar">
      <router-link class="sidebar-brand" to="/">
        <span class="sidebar-brand-text align-middle">
          {{ userInfo.shopInfo.name }}
          <sup><small class="badge bg-danger text-uppercase">Shop</small></sup>
        </span>
      </router-link>
      <div class="sidebar-user">
        <div class="d-flex justify-content-center">
          <div class="flex-shrink-0">
            <img
              src="../assets/img/avatar.png"
              class="avatar img-fluid rounded-circle rounded me-1"
            />
          </div>
          <div class="flex-grow-1 ps-2">
            <a href="javascript:;" style="color: white">
              Chào,
              <span style="font-weight: bold; font-style: italic">{{
                userInfo.full_name
              }}</span>
              <i class="align-middle me-2 fas fa-fw fa-bullhorn"></i>
            </a>
            <div class="badge bg-danger">
              {{ userInfo.role == "manage" ? "Quản lý" : "Nhân viên" }}
            </div>
          </div>
        </div>
      </div>

      <ul class="sidebar-nav">
        <li
          class="sidebar-item"
          :class="[$route.path === '/' ? 'active' : null]"
        >
          <router-link class="sidebar-link" to="/">
            <i class="align-middle" data-feather="grid"></i>
            <span class="align-middle">Bảng điều khiển</span>
          </router-link>
        </li>
        <li
          class="sidebar-item"
          :class="[$route.path === '/users' ? 'active' : null]"
        >
          <router-link class="sidebar-link" to="/users">
            <i class="align-middle" data-feather="users"></i>
            <span class="align-middle">Nhân viên</span>
          </router-link>
        </li>
        <li
          class="sidebar-item"
          :class="[$route.path === '/products' ? 'active' : null]"
        >
          <router-link class="sidebar-link" to="/products">
            <i class="align-middle" data-feather="server"></i>
            <span class="align-middle">Sản phẩm</span>
          </router-link>
        </li>
        <li
          class="sidebar-item"
          :class="[$route.path === '/orders' ? 'active' : null]"
        >
          <router-link class="sidebar-link" to="/orders">
            <i class="align-middle" data-feather="server"></i>
            <span class="align-middle">Đơn hàng</span>
          </router-link>
        </li>
        <li
          class="sidebar-item"
          :class="[$route.path === '/shop-info' ? 'active' : null]"
        >
          <router-link class="sidebar-link" to="/shop-info">
            <i class="align-middle" data-feather="info"></i>
            <span class="align-middle">Thông tin cửa hàng</span>
          </router-link>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
import { mapState } from "vuex"
export default {
  data() {
    return {}
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.auth.userInfo
    })
  },
  methods: {
    onLogout() {
      this.$store.dispatch("auth/logout")
      this.$router.push("/login")
    }
  }
}
</script>

<style lang="css">
.sidebar-item a {
  color: white;
}
.child-active.active .sidebar-link {
    font-weight: 400;
    border-left: 0;
    color: #518be1;
    background: transparent;
}
</style>